<template>
  <div>
    <div
      v-if="rule.name"
      class="mt-2"
    >
      <span class="rounded-full bg-theme-500 px-3 py-1 text-xs font-bold text-white inline-flex flex-grow-0 flex">{{ rule.name }} {{ getRequisitesCreditsRangeLabel(relatedRequisites, [rule]) }}</span>
    </div>
    <div
      v-if="rule.description && rule.description !== '<p></p>'"
      class="mt-2"
    >
      <RichContent  class="reset-liststyle" :content="rule.description" />
    </div>
    <span class="font-bold">{{ displayString }}</span>
    <template v-if="rules && rules.length">
      <RequisitesSimpleRule
        v-for="(subRule, index) in rules"
        :key="`subRule-${index}`"
        :rule="subRule"
        :related-requisites="relatedRequisites"
        class="ml-4 mt-2 mb-4"
        @showModal="$emit('showModal', $event)"
      />
    </template>
    <RequisiteSimpleDataSelect
      v-else-if="shouldShowDataSelect"
      :related-requisites="relatedRequisites"
      :selection="rule.value || {}"
      class="ml-4 pl-4 ruleBorder"
      @showModal="$emit('showModal', $event)"
    />
    <div
      v-if="rule.notes && rule.notes !== '<p></p>'"
      class="ml-4 mt-2"
    >
      <RichContent  class="reset-liststyle" :content="rule.notes" />
    </div>
  </div>
</template>

<script>
import RequisitesSimpleRuleDefaults from '../../RequisitesSimpleRuleDefaults'
import RequisiteSimpleDataSelect from './RequisiteSimpleDataSelect'
import RichContent from '@/components/RichContent'

export default {
  components: { RequisiteSimpleDataSelect, RichContent },
  ...RequisitesSimpleRuleDefaults,
}
</script>

<style scoped>
.ruleBorder {
  border-left: 1px solid black !important;
}
</style>
